import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import Group from './Group/Group.js';

const Container = styled('div') `
  width: 100%;
  max-width: 424px;
`;
const FormWizard = (_a) => {
    var { settings, values, setValue, errors, collapsibleGroups } = _a, rest = __rest(_a, ["settings", "values", "setValue", "errors", "collapsibleGroups"]);
    return (jsx(Container, Object.assign({}, rest, { children: settings
            .filter(settingGroup => !settingGroup.hidden)
            .map(settingGroup => (jsx(Group, { setting: settingGroup, values: values || {}, errors: errors, setValue: setValue, collapsibleGroup: collapsibleGroups }, settingGroup.name))) })));
};

export { FormWizard as default };
//# sourceMappingURL=FormWizard.js.map
